export default __webpack_public_path__ + "static/media/arquimedia.1ca6171e.png";